/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ArrowArcLeft': {
    width: 24,
    height: 13,
    viewBox: '0 0 24 13',
    data: '<path pid="0" d="M7.5 9.105H1v-6.5" _stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M21.895 11.75A9.75 9.75 0 005.25 4.856L2 8.106" _stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
